import sale1 from './assets/sale1.png';
import sale2 from './assets/sale2.png';
import sale3 from './assets/sale3.png';
import sale4 from './assets/sale4.png';
import sale5 from './assets/sale5.png';
import sale6 from './assets/sale6.png';


export const navItems = [
    {
        id: 1,
        title: "Jewellery & Accessories",
        cat: "Accessories",
    },
    {
        id: 2,
        title: "Clothes & Shoes",
        cat: "Clothing",
    },
    {
        id: 3,
        title: "Home & Living",
        cat: "HomeDecor",
    },
    {
        id: 4,
        title: "Crafts & Tools",
        cat: "HandMade",
    },
];



export const sliderItems = [
    {
        id: 1,
        title: "Entreprenual Induction",
        desc: "Sheboss strives to create alternative livelihoods for women and girls living in underserved communities through promoting inclusion and sustainable economic growth.",
        bgImage: "assets/banner3.png",
    },
    {
        id: 2,
        title: "Skills Training",
        desc: "Sheboss strives to create alternative livelihoods for women amd girls living in underserved communities through promoting inclusion and sustainable economic growth.",
        bgImage: "assets/banner2.png",
    },
    {
        id: 3,
        title: "Product Development",
        desc: "Sheboss strives to create alternative livelihoods for women amd girls living in underserved communities through promoting inclusion and sustainable economic growth.",
        bgImage: "assets/banner1.png",
    },
];


export const categories = [
    {
        id: 1,
        img: "assets/handmade.png",
        title: "HAND MADE",
        cat: "HandMade",
    },
    {
        id: 2,
        img: "assets/jewelry.png",
        title: " FINE JEWELRY",
        cat: "Accessories",
    },
    {
        id: 3,
        img: "assets/clothes.png",
        title: "LATEST CLOTHES",
        cat: "Clothing",
    },
    {
        id: 4,
        img: "assets/homedecor.png",
        title: "HOME DECOR",
        cat: "HomeDecor",
        subcat: "Home / Accessories / ViewAll"
    },
];


export const saleProducts = [
    {
        id: 1,
        img: sale1,
        new: "UGX 26,100",
        old: "UGX 87,000",
        desc: "KIDS SETS",
    },

    {
        id: 2,
        img: sale2,
        new: "UGX 26,100",
        old: "UGX 87,000",
        desc: "HOME LIGHTING",
    },
    {
        id: 3,
        img: sale3,
        new: "UGX 26,100",
        old: "UGX 87,000",
        desc: "HOME DECOR",
    },
    {
        id: 4,
        img: sale4,
        new: "UGX 26,100",
        old: "UGX 87,000",
        desc: "DRESSES",
    },
    {
        id: 5,
        img: sale5,
        new: "UGX 26,100",
        old: "UGX 87,000",
        desc: "HAND MADE",
    },
    {
        id: 6,
        img: sale6,
        new: "UGX 26,100",
        old: "UGX 87,000",
        desc: "JEWELRY",
    },
]

